import { visit } from 'unist-util-visit';

/**
 * Plugin de remark para convertir [chip:texto] en nodos personalizados
 * y agruparlos en un contenedor stackeado
 */
export const remarkChipPlugin = () => {
    return (tree) => {
        visit(tree, 'paragraph', (node, index, parent) => {
            // Buscar si este párrafo contiene chips
            let hasChips = false;
            const newChildren = [];
            
            node.children.forEach((child) => {
                if (child.type === 'text' && child.value.includes('[chip:')) {
                    hasChips = true;
                    const parts = child.value.split(/(\[chip:.*?\])/g);
                    
                    parts.forEach((part) => {
                        const chipMatch = part.match(/^\[chip:(.*?)\]$/);
                        
                        if (chipMatch) {
                            newChildren.push({
                                type: 'chip',
                                data: {
                                    hName: 'div',
                                    hProperties: {
                                        className: ['chat-chip-item'],
                                        'data-chip-text': chipMatch[1]
                                    }
                                },
                                children: [{ type: 'text', value: chipMatch[1] }]
                            });
                        } else if (part.trim()) {
                            newChildren.push({ type: 'text', value: part });
                        }
                    });
                } else {
                    newChildren.push(child);
                }
            });
            
            // Si encontramos chips, envolver en un contenedor especial
            if (hasChips) {
                const chipNodes = newChildren.filter(n => n.type === 'chip');
                const textNodes = newChildren.filter(n => n.type !== 'chip');
                
                // Si solo hay chips y nada más, crear contenedor especial
                if (chipNodes.length > 0 && textNodes.every(n => !n.value || !n.value.trim())) {
                    parent.children[index] = {
                        type: 'chipContainer',
                        data: {
                            hName: 'div',
                            hProperties: {
                                className: ['chat-chips-stack']
                            }
                        },
                        children: chipNodes
                    };
                } else {
                    // Si hay texto mezclado, mantener comportamiento inline
                    node.children = newChildren;
                }
            }
        });
    };
};